// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"51d76e61","31":"483e5e67","75":"f2d1a858","88":"8ccb43f8","401":"31a970ec","444":"f2d1a858","537":"d7d63f8f","556":"53f5c743","623":"3a7a0dc9","628":"9ff8c792"}[chunkId] + ".chunk.css";
};